// MSAL (Microsoft Entra / Azure AD) configuration.
//
// clientId/tenantId come from env vars, matching this project's REACT_APP_*
// convention (see REACT_APP_GOOGLE_APP_CLIENT_ID). Microsoft login is only
// enabled when a client id is present, so Google-only deployments are unaffected.

export const MICROSOFT_CLIENT_ID = process.env.REACT_APP_MICROSOFT_CLIENT_ID;
export const MICROSOFT_TENANT_ID = process.env.REACT_APP_MICROSOFT_TENANT_ID;

// Email domain Microsoft logins are restricted to for this project.
// (Google is restricted separately to instylesolar.com.au.)
export const MICROSOFT_DOMAIN = 'nectr.com.au';

export const microsoftEnabled = !!MICROSOFT_CLIENT_ID;

export const msalConfig = {
    auth: {
        clientId: MICROSOFT_CLIENT_ID,
        authority: `https://login.microsoftonline.com/${MICROSOFT_TENANT_ID}`,
        // Dedicated blank redirect route so the popup fragment (#code=...) is not
        // stripped by an app redirect before the opener reads it.
        redirectUri: window.location.origin + '/entra-auth',
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
};

export const loginRequest = {
    scopes: ['openid', 'profile', 'email'],
};
